var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RePhoneCallButton"},[_c('base-button',{staticClass:"btn btn-icon mt-0",class:[{'no-border': _vm.borderStyle=='noborder'}],attrs:{"type":"success","simple":""},on:{"click":_vm.callAgent}},[_c('i',{staticClass:"tim-ic ic-phone pt-1"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }